/* ==========================================================================
   LT INTERNATIONAL — FLAGSHIP PRODUCT CONFIGURATOR SCRIPT (V10)
   ========================================================================== */

document.addEventListener("DOMContentLoaded", () => {
  initProductConfigurator();
});

function initProductConfigurator() {
  // Elements
  const packageRows = document.querySelectorAll("#package-select .purchase-option-row");
  const subscriptionRows = document.querySelectorAll("#subscription-select .purchase-option-row");
  const partnerRows = document.querySelectorAll("#partner-select .purchase-option-row");
  
  const priceDisplay = document.getElementById("active-price-display");
  const comparePrice = document.getElementById("compare-price-display");
  
  const benefitsBox = document.getElementById("benefits-info-box");
  const benefitsTitle = document.getElementById("benefits-box-title");
  const benefitsText = document.getElementById("benefits-box-text");
  
  const buyBtn = document.getElementById("pdp-buy-btn");

  // Selection states
  let selectedPackage = "600tabs";
  let packagePrice = 498;
  
  let selectedSub = "once";
  let subDiscount = 0.0;
  
  let selectedPartner = "none";
  let partnerPrice = 0;

  // Benefits library based on partner plans from flyers
  const partnerBenefits = {
    none: "",
    pioneer: {
      title: "PIONEER MEMBER SYSTEM ACTIVATED ⚡",
      text: "Instant value: You receive 12 bottles of CRIII Original (600 Tabs) [Worth RM5,976] + 12 bottles of CRIII Original (300 Tabs) FREE [Worth RM3,180] + Earn Bonus pool access. Total package value worth RM9,156+. Benefits include event subsidies, standard training, private dinner invitations, and closed-door inner circleupdates."
    },
    business: {
      title: "ELITE BUSINESS PARTNER SYSTEM ACTIVATED 👑",
      text: "Instant value: You receive 12 bottles of CRIII Original (600 Tabs) [Worth RM5,976] + 12 bottles of CRIII Original (600 Tabs) FREE [Worth RM5,976] + 2 boxes of Liquid Extract [Worth RM4,998] + 1 box of Liquid Extract FREE [Worth RM2,499]. Total value worth over RM19,449+! Benefits include max earn bonuses, priority access to upcoming innovations, AI Courses & Business System tools, and training + private dinners."
    }
  };

  // 1. Package Selections
  packageRows.forEach(row => {
    row.addEventListener("click", () => {
      if (selectedPartner !== "none") {
        alert("Clinical System: Standard retail package select is locked during Elite Partner enrollment. Please select 'Standard Retail Plan' under Elite Partner Upgrade first.");
        return;
      }
      packageRows.forEach(r => r.classList.remove("selected"));
      row.classList.add("selected");
      
      selectedPackage = row.dataset.package;
      packagePrice = parseFloat(row.dataset.price);
      
      updatePricing();
    });
  });

  // 2. Subscription Selections
  subscriptionRows.forEach(row => {
    row.addEventListener("click", () => {
      if (selectedPartner !== "none") {
        alert("Clinical System: Subscription plans are only applicable to standard retail purchases. Elite Partner programs carry unified membership values.");
        return;
      }
      subscriptionRows.forEach(r => r.classList.remove("selected"));
      row.classList.add("selected");
      
      selectedSub = row.dataset.sub;
      subDiscount = parseFloat(row.dataset.discount);
      
      updatePricing();
    });
  });

  // 3. Partner Selections
  partnerRows.forEach(row => {
    row.addEventListener("click", () => {
      partnerRows.forEach(r => r.classList.remove("selected"));
      row.classList.add("selected");
      
      selectedPartner = row.dataset.partner;
      partnerPrice = parseFloat(row.dataset.price);
      
      // Update UI elements based on partner select
      if (selectedPartner !== "none") {
        // Blur out standard cards to indicate elite state
        document.getElementById("package-select").style.opacity = "0.38";
        document.getElementById("subscription-select").style.opacity = "0.38";
        
        // Show benefits
        benefitsBox.style.display = "block";
        const ben = partnerBenefits[selectedPartner];
        benefitsTitle.textContent = ben.title;
        benefitsText.textContent = ben.text;
      } else {
        document.getElementById("package-select").style.opacity = "1";
        document.getElementById("subscription-select").style.opacity = "1";
        benefitsBox.style.display = "none";
      }
      
      updatePricing();
    });
  });

  function updatePricing() {
    if (selectedPartner !== "none") {
      // Flat Pioneer/Business pricing
      priceDisplay.textContent = `RM${partnerPrice.toFixed(2)}`;
      comparePrice.style.display = "inline";
      
      const worth = selectedPartner === "pioneer" ? 9156 : 19449;
      comparePrice.textContent = `Worth RM${worth.toFixed(2)}`;
    } else {
      // Standard Retail calculation with sub discount
      const discountedPrice = packagePrice * (1.0 - subDiscount);
      priceDisplay.textContent = `RM${discountedPrice.toFixed(2)}`;
      
      if (subDiscount > 0) {
        comparePrice.style.display = "inline";
        comparePrice.textContent = `RM${packagePrice.toFixed(2)}`;
      } else {
        comparePrice.style.display = "none";
      }
    }

    // Update B2C Subscription Pricing Matrix dynamically
    const unitText = selectedPackage === "liquid" ? "/ box" : "/ bottle";
    
    // Calculate card prices
    const priceOnce = packagePrice;
    const price3months = packagePrice * 0.95;
    const price6months = packagePrice * 0.93;
    const price12months = packagePrice * 0.90;
    
    // Select elements and update
    const cardPriceOnce = document.getElementById("card-price-once");
    const cardPeriodOnce = document.getElementById("card-period-once");
    const cardDescOnce = document.getElementById("card-desc-once");
    
    const cardPrice3months = document.getElementById("card-price-3months");
    const cardPeriod3months = document.getElementById("card-period-3months");
    
    const cardPrice6months = document.getElementById("card-price-6months");
    const cardPeriod6months = document.getElementById("card-period-6months");
    
    const cardPrice12months = document.getElementById("card-price-12months");
    const cardPeriod12months = document.getElementById("card-period-12months");
    const cardSavings12months = document.getElementById("card-savings-12months");
    const cardDesc12months = document.getElementById("card-desc-12months");
    
    if (cardPriceOnce) cardPriceOnce.textContent = priceOnce.toFixed(2).replace(".00", "");
    if (cardPeriodOnce) cardPeriodOnce.textContent = unitText;
    if (cardDescOnce) {
      if (selectedPackage === "600tabs") {
        cardDescOnce.textContent = "Full 600 chewable tablets loading routine";
      } else if (selectedPackage === "300tabs") {
        cardDescOnce.textContent = "Full 300 chewable tablets baseline protection";
      } else {
        cardDescOnce.textContent = "Full 10-vial ultimate cellular infusion routine";
      }
    }
    
    if (cardPrice3months) cardPrice3months.textContent = price3months.toFixed(2).replace(".00", "");
    if (cardPeriod3months) cardPeriod3months.textContent = unitText;
    
    if (cardPrice6months) cardPrice6months.textContent = price6months.toFixed(2).replace(".00", "");
    if (cardPeriod6months) cardPeriod6months.textContent = unitText;
    
    if (cardPrice12months) cardPrice12months.textContent = price12months.toFixed(2).replace(".00", "");
    if (cardPeriod12months) cardPeriod12months.textContent = unitText;
    
    if (cardSavings12months) {
      const freeItem = selectedPackage === "liquid" ? "FREE Box" : "FREE Bottle";
      cardSavings12months.textContent = `Save 10% OFF + 1 Extra ${freeItem}`;
    }
    if (cardDesc12months) {
      if (selectedPackage === "600tabs") {
        cardDesc12months.textContent = "Complimentary 13th bottle of CRIII 600 Tabs";
      } else if (selectedPackage === "300tabs") {
        cardDesc12months.textContent = "Complimentary 13th bottle of CRIII 300 Tabs";
      } else {
        cardDesc12months.textContent = "Complimentary 11th box of Extract Liquid";
      }
    }

    // Update main PDP 12-Month subscription row labels dynamically
    const pdpSubLabel = document.getElementById("pdp-sub-12months-label");
    const pdpSubPrice = document.getElementById("pdp-sub-12months-price");
    const bonusItem = selectedPackage === "liquid" ? "FREE Box" : "FREE Bottle";
    
    if (pdpSubLabel) pdpSubLabel.textContent = `1 Extra ${bonusItem}`;
    if (pdpSubPrice) pdpSubPrice.textContent = `10% OFF + ${bonusItem}`;
  }

  // Buy click trigger secure alert
  if (buyBtn) {
    buyBtn.addEventListener("click", () => {
      let message = "";
      if (selectedPartner !== "none") {
        message = `Processing Elite ${selectedPartner === "pioneer" ? "Pioneer" : "Business Partner"} enrollment for RM${partnerPrice}! Secure checkout initiated.`;
      } else {
        const discountedPrice = packagePrice * (1.0 - subDiscount);
        message = `Added ${selectedPackage === "special" ? "Mother's & Father's Special Package" : selectedPackage} to secure checkout for RM${discountedPrice.toFixed(2)}!`;
      }
      alert(message);
    });
  }

  // Listen for global B2B/B2C view toggle events
  document.addEventListener("viewChanged", (e) => {
    syncConfiguratorWithView(e.detail.view);
  });

  function syncConfiguratorWithView(view) {
    if (view === "b2b") {
      const pioneerRow = Array.from(partnerRows).find(r => r.dataset.partner === "pioneer");
      if (pioneerRow && selectedPartner === "none") {
        partnerRows.forEach(r => r.classList.remove("selected"));
        pioneerRow.classList.add("selected");
        selectedPartner = "pioneer";
        partnerPrice = 6000;
        
        document.getElementById("package-select").style.opacity = "0.38";
        document.getElementById("subscription-select").style.opacity = "0.38";
        
        benefitsBox.style.display = "block";
        const ben = partnerBenefits["pioneer"];
        benefitsTitle.textContent = ben.title;
        benefitsText.textContent = ben.text;
        
        updatePricing();
      }
    } else {
      const noneRow = Array.from(partnerRows).find(r => r.dataset.partner === "none");
      if (noneRow && selectedPartner !== "none") {
        partnerRows.forEach(r => r.classList.remove("selected"));
        noneRow.classList.add("selected");
        selectedPartner = "none";
        partnerPrice = 0;
        
        document.getElementById("package-select").style.opacity = "1";
        document.getElementById("subscription-select").style.opacity = "1";
        benefitsBox.style.display = "none";
        
        updatePricing();
      }
    }
  }

  // Sync state on load
  const initialView = localStorage.getItem("view") || "b2c";
  syncConfiguratorWithView(initialView);

  // Trigger initial pricing updates
  updatePricing();

  // 4. Specification Accordion Swaps
  const accTriggers = document.querySelectorAll(".spec-acc-trigger");
  accTriggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      const content = trigger.nextElementSibling;
      const chevron = trigger.querySelector(".acc-chevron");
      
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        if (chevron) chevron.style.transform = "rotate(0deg)";
      } else {
        // Close other accordions
        accTriggers.forEach(t => {
          t.nextElementSibling.style.maxHeight = null;
          const chev = t.querySelector(".acc-chevron");
          if (chev) chev.style.transform = "rotate(0deg)";
        });

        content.style.maxHeight = content.scrollHeight + "px";
        if (chevron) chevron.style.transform = "rotate(180deg)";
      }
    });
  });

  // Open first accordion by default
  if (accTriggers.length > 0) {
    setTimeout(() => {
      accTriggers[0].click();
    }, 100);
  }
}
